import http from 'services/http';

export async function createWebsocketToken() {
  return http.post<{ token: string }>(`/me/websocket_token`).then((response) => response.data.token);
}
